import { exampleJS } from "./modules/exampleJS";
import { footerAnimation } from "./modules/footerAnimation";
import { faqOpen } from "./modules/blocks";
import { internalMenuClose } from "./modules/blocks";
import { blueStairsAnimation } from "./modules/gsapAnimations";
import { menuMobile } from "./modules/menuMobile";
import { menuDesktop } from "./modules/menuDesktop";
import { heatmapAnimation } from "./modules/heatmapAnimation";
import { heatmapBarsAnimation } from "./modules/heatmapBarsAnimation";
import { blockHeroMediaAnimation } from "../../includes/blocks/block-hero-media-animation/script";
import { blockLogosSlider } from "../../includes/blocks/block-logos-slider/script";
import { blockHeroVideoAnimation } from "../../includes/blocks/block-hero-video-animation/script";
import { blockWheelSlider } from "../../includes/blocks/block-wheel-slider/script";
import { heroBackgroundAnimation } from "./modules/heroBackgroundAnimation";
import { caseTaxToggle } from "./modules/caseTaxToggle";
import { activeMenu } from "./modules/activeMenu";

if (document.querySelector(".exampleJS")) {
  exampleJS();
}

if (document.querySelector(".tenesys-block-footer-animation")) {
  footerAnimation();
}

if (document.querySelector(".tenesys-block-accordion .kt-accordion-pane")) {
  faqOpen();
}
if (
  document.querySelector(
    ".tenesys-tablet-mobile-internal-menu .kt-accordion-pane",
  )
) {
  internalMenuClose();
}

if (document.querySelector(".tenesys-block-stairs-animation")) {
  blueStairsAnimation();
}

if (document.querySelector(".mobile-menu-dialog")) {
  menuMobile();
}
if (document.querySelector(".tenesys-block-heatmap-animation")) {
  heatmapAnimation();
}
if (document.querySelector(".tenesys-block-heatmap-bars-animation")) {
  heatmapBarsAnimation();
}

if (document.querySelector(".blockHeroMediaAnimation")) {
  console.log("blockHeroMediaAnimation1");
  blockHeroMediaAnimation();
}
if (document.querySelector(".blockLogosSlider")) {
  blockLogosSlider();
}
if (document.querySelector(".blockHeroVideoAnimation")) {
  blockHeroVideoAnimation();
}

if (document.querySelector(".wp-block-kadence-header-desktop")) {
  menuDesktop();
}

if (document.querySelector(".blockWheelSlider")) {
  blockWheelSlider();
}

if (document.querySelector(".tenesys-hero-background-animation")) {
  heroBackgroundAnimation();
}

if (document.querySelector(".case-card-categories__more")) {
  caseTaxToggle();
}

if (document.querySelector(".wp-block-kadence-header-desktop")) {
  activeMenu();
}

(function () {
  function initSolutionsSwitcher(linksSelector, imagesSelector) {
    const linksWrapper = document.querySelector(linksSelector);
    const imagesWrapper = document.querySelector(imagesSelector);

    if (!linksWrapper || !imagesWrapper) return;

    const links = linksWrapper.querySelectorAll('.text-7-button');
    const images = imagesWrapper.querySelectorAll('.links-image');

    links.forEach(link => {
      const handler = function (e) {
        // if (e.type === 'click') e.preventDefault();

        const id = this.id;
        if (!id) return;

        links.forEach(l => l.classList.remove('active'));
        this.classList.add('active');

        images.forEach(img => img.classList.remove('active'));

        const targetImg = imagesWrapper.querySelector('#' + id + '-img');
        if (targetImg) {
          targetImg.classList.add('active');
        }
      };

      link.addEventListener('mouseenter', handler);
      link.addEventListener('click', handler);
    });

    // opcjonalnie: aktywuj pierwszy na start
    const first = links[0];
    if (first) {
      first.classList.add('active');
      const firstImg = imagesWrapper.querySelector('#' + first.id + '-img');
      if (firstImg) firstImg.classList.add('active');
    }
  }

  initSolutionsSwitcher('.solutions-links', '.solutions-links-images');
  initSolutionsSwitcher('.sectors-links', '.sectors-links-images');
  initSolutionsSwitcher('.blogs-links', '.blogs-links-images');
  initSolutionsSwitcher('.about-links', '.about-links-images');
})();

(function () {
  // const targets = document.querySelectorAll(
  //   '.wp-block-kadence-header-section1942_4720e9-30 .wp-block-kadence-header-column, ' +
  //   '.wp-block-kadence-header-tablet .wp-block-kadence-header-column-center-right, ' +
  //   '.wp-block-kadence-header-column, ' +
  //   '.wp-block-kadence-header-tablet .wp-block-kadence-header-column-center-right'
  // );
  const targets = document.querySelectorAll(
    '.wp-block-kadence-header-section1942_4720e9-30 .wp-block-kadence-header-column, .wp-block-kadence-header-tablet .wp-block-kadence-header-column-center-right, .wp-block-kadence-header-section4543_aa4d0c-f7 .wp-block-kadence-header-column, .wp-block-kadence-header-section4543_762c29-04 .wp-block-kadence-header-column'
  );

//wp-block-kadence-header-section4543_aa4d0c-f7

  if (!targets.length) return;

  const htmlLang = document.documentElement.lang.toLowerCase();

  let targetLang = 'en';
  let label = 'EN';
  let fallbackUrl = '/en/';

  if (htmlLang.startsWith('en')) {
    targetLang = 'pl';
    label = 'PL';
    fallbackUrl = '/';
  }

  let finalUrl = fallbackUrl;

  // 🔥 sprawdzamy WPML switcher czy ma link do tłumaczenia
  const wpml = document.querySelector('.wpml-ls');
  if (wpml) {
    const items = wpml.querySelectorAll('.wpml-ls-item');

    items.forEach(item => {
      const link = item.querySelector('a');
      if (!link) return;

      // szukamy odpowiedniego języka po klasie
      if (item.classList.contains('wpml-ls-item-' + targetLang)) {
        finalUrl = link.href;
      }
    });
  }

  targets.forEach(target => {
    if (!target) return;

    const existing = target.querySelector('.custom-lang-toggle');
    if (existing) existing.remove();

    const toggle = document.createElement('a');
    toggle.href = finalUrl;
    toggle.className = 'custom-lang-toggle';
    toggle.textContent = label;

    target.insertBefore(toggle, target.firstChild);
  });
})();


(function () {

  function initKadenceFilters() {
  document.querySelectorAll('.kadence-query-filter').forEach(filter => {
    const select = filter.querySelector('select.kb-filter');
    if (!select) return;

    // jeśli już istnieje custom UI → nie buduj drugi raz
    if (filter.querySelector('.custom-filter')) return;

    const custom = document.createElement('div');
    custom.className = 'custom-filter';

    const trigger = document.createElement('div');
    trigger.className = 'custom-filter__trigger';
    trigger.textContent = select.options[select.selectedIndex]?.text || 'Filter';

    const arrow = `<div class="custom-filter__trigger-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_4994_4789" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
<rect width="24" height="24" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_4994_4789)">
<path d="M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z" fill="#646464"/>
</g>
</svg></div>`;

trigger.innerHTML += arrow;

    const optionsWrap = document.createElement('div');
    optionsWrap.className = 'custom-filter__options';

    Array.from(select.options).forEach(option => {
      if (!option.value) return;

      const opt = document.createElement('div');
      opt.className = 'custom-filter__option';
      opt.textContent = option.textContent;
      opt.dataset.value = option.value;

      opt.addEventListener('click', () => {
        select.value = option.value;
        select.dispatchEvent(new Event('change'));

        trigger.textContent = option.textContent;
        custom.classList.remove('open');
      });

      optionsWrap.appendChild(opt);
    });

    trigger.addEventListener('click', () => {
      custom.classList.toggle('open');
    });

    document.addEventListener('click', e => {
      if (!custom.contains(e.target)) {
        custom.classList.remove('open');
      }
    });

    custom.appendChild(trigger);
    custom.appendChild(optionsWrap);

    select.parentElement.appendChild(custom);
  });
}

// initial run
initKadenceFilters();

// 🔥 OBSERVER – Kadence refresh protection
const observer = new MutationObserver(() => {
  initKadenceFilters();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
})();

document.addEventListener('DOMContentLoaded', () => {
    const navLinks = document.querySelectorAll('.wp-block-kadence-header-section .kb-nav-link-content[href="#"]');

    navLinks.forEach(link => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
        });
    });



    document.querySelectorAll('.wp-block-kadence-header-desktop .kt-tabs-title-list li.kt-title-item').forEach(li => {
        li.addEventListener('mouseenter', () => {
            const link = li.querySelector('a.kt-tab-title');
            if (link) {
                link.click();
            }
        });
    });
});